import { DumbAttachment } from "../../pending-news/DTOs/dumb-news-attachment";

export class ResourcePageDetails {
    constructor() {
        this.attachments = [];
    }

    pageId: number;
    pageName: string;
    pageContent: string;
    category: number;
    mainImageId: string;
    mainImageUrl: string;
    attachments: DumbAttachment[];
}